// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
const { isEmpty } = _uo.utility;

// Import style for web component
import styles from './web-component-style.scss';

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.itemLoop;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-loop-menu-button-support' )
export class AutomatorBuilderLoopMenuButtonSupport extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-button
				color="transparent"
				href=${ UncannyAutomator._site.automator.links.loops_guide }
				target="_blank"
			>
				${ strings.support } <uo-icon id="external-link"></uo-icon>
			</uo-button>
		`;
	}
}
